import type { SortOptions } from '@lib/util/sort-products';

export const PLP_FIELDS =
  '*variants.calculated_price,*variants.images,+metadata,+tags,*categories,+product_popularity.units_sold';

// Matches the per-page limit used across the PLP templates (server-products,
// price-sorted-products, popularity-sorted-products, categories/collections
// page.tsx) and the Pagination component's page/pageSize model. Single
// source of truth — see A/C: "maximum of 24 products per page".
export const PRODUCTS_PAGE_SIZE = 24;

export type ProductQueryParams = {
  limit: number;
  collection_id?: string[];
  category_id?: string[];
  id?: string[];
  order?: string;
  q?: string;
};

export type BuildProductQueryInput = {
  collectionId?: string;
  categoryId?: string;
  productsIds?: string[];
  searchQuery?: string;
  sort: SortOptions;
  limit: number;
};

const SORT_ORDER: Partial<Record<SortOptions, string>> = {
  title_asc: 'title',
  title_desc: '-title',
};

function sortToOrder(sort: SortOptions): string | undefined {
  return SORT_ORDER[sort];
}

// Medusa's list endpoint requires single IDs wrapped in arrays
function buildArrayFilters(
  collectionId: string | undefined,
  categoryId: string | undefined,
): Partial<ProductQueryParams> {
  return {
    ...(collectionId && { collection_id: [collectionId] }),
    ...(categoryId && { category_id: [categoryId] }),
  };
}

export function buildProductQueryParams({
  collectionId,
  categoryId,
  productsIds,
  searchQuery,
  sort,
  limit,
}: BuildProductQueryInput): ProductQueryParams {
  return {
    limit,
    ...(productsIds && { id: productsIds }),
    ...(searchQuery && { q: searchQuery }),
    order: sortToOrder(sort),
    ...buildArrayFilters(collectionId, categoryId),
  };
}
